import moment from 'moment'
import {PaginateModel} from '../../../shared/models/PaginateModel'
import {DATE_FORMAT} from '../../../shared/constants'

export interface PaymentRequestFilterModel extends PaginateModel {
  startDate?: string
  endDate?: string
}

export const createDefaultTransactionRequestFilter = (): PaymentRequestFilterModel => ({
  page: 1,
  pageCount: 0,
  take: Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) ?? 10,
  itemCount: 0,
  startDate: moment().startOf('month').format(DATE_FORMAT),
  endDate: moment().format(DATE_FORMAT),
})

export const validateTransactionRequestFilter = (
  filter: PaymentRequestFilterModel
): {isValid: boolean; errors: string[]} => {
  const errors: string[] = []

  // Validate start date and end date
  if (filter.startDate && filter.endDate) {
    const startDate = new Date(filter.startDate)
    const endDate = new Date(filter.endDate)

    if (startDate > endDate) {
      errors.push('Start date must be before end date')
    }
  }

  // Validate date format
  if (filter.startDate && isNaN(Date.parse(filter.startDate))) {
    errors.push('Invalid start date format')
  }

  if (filter.endDate && isNaN(Date.parse(filter.endDate))) {
    errors.push('Invalid end date format')
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}
